import GroupContextBiologicalsListing from "../../components/biologicals/GroupContextBiologicalsListing.vue";
import MultiBiologicalsListing from "../../components/biologicals/MultiBiologicalsListing.vue";

require("./css/Bio.css");

const globalComponents = {
  GroupContextBiologicalsListing,
  MultiBiologicalsListing,
};

const routes = [];

export {
  globalComponents as bioListingGlobalComponents,
  routes as bioListingRoutes,
};
